// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"1074747f","115":"30698b6f","137":"b0342d3a","273":"2a43b15a","402":"2dc91d45","724":"97136230","892":"4d34db63"}[chunkId] + ".chunk.js";
};